import { ITestingEmail } from "../../models/TestingEmailSetting";


export const EmptyTestingEmail: ITestingEmail = {
  
    setting_Id: 0,
    sales_Email: null,
    recruiter_Email: null,
    sales_Head_Email: null,
    recruiter_Head_Email: null,
    branch_Head_Email: null,
    consultant_Email: null
}

